


































import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import { MaintenanceType } from '@superbet-group/web.types';
import {
    computed,
    defineComponent,
} from '@vue/composition-api';

import { CompetitionDataStore } from '@sportOfferFederation/competitions/store/data';
import {
    SdsCarousel,
    SdsSectionTitle,
} from '@superbet-group/web.lib.ui-components';

import HotTournamentCard from './HotTournamentCard.vue';
import { MaintenanceStore } from '@store/modules/data/maintenance/maintenanceIndex';

export default defineComponent({
    name: 'HotTournamentsCarousel',
    props: {
        sportId: {
            type: Number,
            required: false,
            default: undefined,
        },
        showIcon: {
            type: Boolean,
            required: false,
            default: true,
        },
        titleTranslationKey: {
            type: String,
            required: false,
            default: 'hot tournaments',
        },
        titleDescription: {
            type: String,
            required: false,
            default: undefined,
        },
    },
    setup(props) {
        const competitionDataStore = useVuexStore<CompetitionDataStore>('data/competitions');
        const maintenanceStore = useVuexStore<MaintenanceStore>('data/maintenance');

        const homepageHotTournaments = competitionDataStore.getter('homeHotTournaments');
        const getHotTournamentsBySportId = competitionDataStore.getter('getHotTournamentsPrematchBySportId');
        const getIsInMaintenance = maintenanceStore.getter('isInMaintenance');

        const hotTournaments = computed(() => {
            return props.sportId
                ? getHotTournamentsBySportId.value(props.sportId)
                : homepageHotTournaments.value;
        });

        return {
            hotTournaments,
            isInPrematchMaintenance: computed(() => getIsInMaintenance.value(MaintenanceType.Prematch)),
        };
    },
    components: {
        HotTournamentCard,
        SdsSectionTitle,
        SdsCarousel,
    },
});
